import React, { useEffect, useState } from 'react';
import { Box, Skeleton, VStack, HStack } from 'native-base';
import { useSpringBigStore, useUpdateGiftCardBalances } from '@springbig/shared';
import { Caption, CaptionError } from '~/shared/Typography';
import { faClockRotateLeft } from '@fortawesome/free-solid-svg-icons';
import { SpIcon } from '~/shared/Icon';
import { formatDistanceToNow, isAfter, add } from 'date-fns';
import { useTheme } from '@springbig/shared';
import { Button } from '~/shared/Theme';

const Cash = () => {

    const { member, giftCards, merchant } = useSpringBigStore();
    const [balance, setBalance] = useState<string>();
    const [humanReadableLastUpdated, setHumanReadableLastUpdated] = useState<string>();
    const [lastUpdated, setLastUpdated] = useState<Date>();

    const { primary } = useTheme();

    const { mutate: updateGiftCardBalances, error, isLoading } = useUpdateGiftCardBalances();

    const fetchUpdatedBalance = () => {

        const isMoreThanFiveMinutesAgo = isAfter(new Date(), add(new Date(lastUpdated), { minutes: 5 }));

        if (!lastUpdated || isMoreThanFiveMinutesAgo) {
            updateGiftCardBalances({
                member_id: member.id.toString(),
            }, {
                onSuccess: (response) => {

                    setHumanReadableLastUpdated(formatDistanceToNow(new Date(response.last_updated || Date.now()),
                        { includeSeconds: true }));
                    setLastUpdated(new Date(response.last_updated || Date.now()));
                    setBalance((response.new_balance * 0.01).toFixed(2));
                },
            });
        }
    };

    if (lastUpdated) {

        setInterval(() => setHumanReadableLastUpdated(formatDistanceToNow(new Date(lastUpdated || Date.now()), { includeSeconds: true })),1000 * 60);
    }

    useEffect(() => {

        if (member) {
            fetchUpdatedBalance();
        }
    },[]);

    return (
        <Box alignItems={'center'} px={4} flex={1}>
            { !error &&
                <CaptionError></CaptionError>
            }
            { (!isLoading && balance) ?
                <Caption fontSize={36} fontWeight={'300'}>
                    ${ balance }
                </Caption>
                :
                <Skeleton h={'2rem'} w={'8rem'} rounded={'lg'} />
            }
            <Caption
                fontSize={22}
                fontWeight={'100'}
                text="giftCard.balance.cash_balance"
                textValues={[merchant?.gift_card_alias]}
            />
            { giftCards.length > 0 &&
                <Button
                    variant={'text'}
                    modifier={'unlocked'}
                    onPress={fetchUpdatedBalance}
                >
                    <HStack space={2} alignItems={'center'}>
                        { humanReadableLastUpdated ?
                            <VStack alignItems={'center'}>
                                <Caption fontSize={14}>last updated</Caption>
                                <Caption fontSize={14}> { humanReadableLastUpdated } ago </Caption>
                            </VStack> :
                            <Skeleton.Text lines={2} w='6rem' m={2}/>

                        }
                        { lastUpdated &&
                            <SpIcon color={primary} icon={faClockRotateLeft}/>
                        }
                    </HStack>
                </Button>
            }
        </Box>
    );
};

export default Cash;

